import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot,
  Router, CanActivateChild } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService,
              private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // return true;
    if (this.authService.isAuthenticated()) {
      let urlPrefix = state.url ? state.url.substring(8) : ''; // cut off "/manage"
      urlPrefix = urlPrefix.split('/', 2).join('/');
      this.authService.checkPermission(urlPrefix);
      return true;
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate(['manage/login']);
    return false;
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }
}
